export default [
  {
    path: '/notifications/demandesIncriptionsPromoteurs',
    name: 'notifications-demandesIncriptionsPromoteurs',
    component: () => import('@/views/apps/notifications/NotifsInscriptionsPromoteursEtablissements.vue'),
  },
]
